import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Formik} from "formik";
import s from "./PaymentByBankTransactionTemplate.module.css";
import styles from "../../../styles/styles.module.css";
import {Popover} from "antd";
import info from "../../../assets/img/personalAccount/information.svg";
import classnames from "classnames";
import {motion} from "framer-motion";
import {useNavigate} from "react-router-dom";
import TransparentButton from "../../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../../assets/img/personalAccount/back.svg";
import MyBtn from "../../ui/MyBtn/MyBtn";
import CustomDropdown from "../../ui/CustomDropdown/CustomDropdown";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import CustomDropdownForAccounts from "../../ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import MyInput from "../../ui/MyInput/MyInput";
import {
    getChallengeDataThunk,
    getFeesForTransaction,
    getTemplateByIdThunk,
} from "../../../store/reducers/ActionCreators";
import {ITemplate} from "../../../types/interfaces";
import {SwiftCheckerHelper} from "../../BankTransferFormPersonal/FormHelpers/FormHelpers";
import {PrepareDataForBankTransaction} from "../../../helpers/prepareDataForTransactions/PrepareDataForTranzactions";
import {setIsLoading} from "../../../store/reducers/UserSlice";
import {useSelector} from "react-redux";
import {selectAccountsByFilter} from "../../../store/reducers/TransactionsSlice/selector";
import {Persist} from "formik-persist";
import CustomModal from "../../ui/CustomModal/CustomModal";
import {areLimitsExceeded} from '../../../helpers/LimitsHelper';
import PopUpTwoFaCodConfirm from '../../ui/PopUpTwoFaCodConfirm/PopUpTwoFaCodConfirm';
import DomesticEur from "../../BankTransferFormPersonal/FieldsForPaymentTypes/DomesticEur";
import InternationalEur from "../../BankTransferFormPersonal/FieldsForPaymentTypes/InternationalEur";
import DomesticGbp from "../../BankTransferFormPersonal/FieldsForPaymentTypes/DomesticGbp";
import InternationalGbp from "../../BankTransferFormPersonal/FieldsForPaymentTypes/InternationalGbp";
import CustomCheckbox from "../../ui/customCheckbox/CustomCheckbox";
import DomesticUsd from "../../BankTransferFormPersonal/FieldsForPaymentTypes/AchUsd";
import {amountValidationSchema} from "../../BankTransferFormPersonal/FormHelpers/ValidationSchemas";
import AchUsd from "../../BankTransferFormPersonal/FieldsForPaymentTypes/AchUsd";
import SwiftUsd from "../../BankTransferFormPersonal/FieldsForPaymentTypes/SwiftUsd";
import UsdFedwire from "../../BankTransferFormPersonal/FieldsForPaymentTypes/UsdFedwire";
import CurrencyHelper from "../../../helpers/CurrencyHelper";
import {setTransferDataPreview} from "../../../store/reducers/TransactionsSlice/TransactionsSlice";
import AddDoc from "../../AddDoc/AddDoc";

type PropsType = {
    setCurrent?: Dispatch<SetStateAction<number>>
    setTransferData?: Dispatch<SetStateAction<any>>
    id?: string | number;
    setPurpose: Dispatch<SetStateAction<string>>
    isButtonDisable: boolean
}

const PaymentByBankTransactionTemplate = (props: PropsType) => {
    const navigate = useNavigate()

    const [paymentBankTemplate, setPaymentBankTemplate] = useState<ITemplate>()
    const [isShowPaymentSentSuccessModal, setIsShowPaymentSentSuccessModal] = useState(false)

    const accountsList = useSelector(selectAccountsByFilter)
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const dispatch = useAppDispatch()
    const [isMobile, setIsMobile] = useState(false)
    const [currency, setCurrency] = useState('')
    const [localyDisabled, setLocalyDisabled] = useState(false)

    const limitsInfo = useAppSelector(state => state.userReducer.userLimits);
    const [isLimitPopupOpen, setIsLimitPopupOpen] = useState<boolean | null>(false)
    const [limitType, setLimitType] = useState<string | null>('');

    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState<boolean | null>(false)
    const [isShowEmailPopUpCode, setIsShowEmailPopUpCode] = useState(false)

    const [isTwoFaCodeValid, setIsTwoFaCodeValid] = useState('')
    const [isIbanWrong, setIsIbanWrong] = useState(false)
    const [selectedOptionRecipientType, setSelectedOptionRecipientType] = useState("INDIVIDUAL")
    const [isDocumentErrorModalOpen, setIsDocumentErrorModalOpen] = useState<boolean | null>(false)
    const [documentErrorModalText, setDocumentErrorModalText] = useState<string | null>('')

    const getPinTwoFa = (twoFaCode: string) => {
        setIsTwoFaCodeValid(twoFaCode)
    }

    const closeEmailPinPopUp = () => {
        setIsShowEmailPopUpCode(false)
        setLocalyDisabled(false)
    }

    const clearEmailPin = () => {
        setIsTwoFaCodeValid('')
        setIsErrorPopupOpen(false)
    }

    const errorAndRedirect = () => {
        setIsLimitPopupOpen(false)
        sessionStorage.removeItem("transfer-form")
        navigate('/personal-account/templates')
    }

    useEffect(() => {
        areLimitsExceeded(limitsInfo, setLimitType, setIsLimitPopupOpen);
    })

    useEffect(() => {
        dispatch(getTemplateByIdThunk(token, props.id, accountId))
            .then((res) => {
                if (res.data.type === 'Internal') {
                    props.setPurpose('Transfer to a LuxPay User')
                } else {
                    setPaymentBankTemplate(res.data)
                }
            })
        return () => {
            localStorage.removeItem('transfer-form')
        }
    }, [])

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }, [window.innerWidth])

    useEffect(() => {
        if (paymentBankTemplate) {
            const type = paymentBankTemplate.recipientType ||
                paymentBankTemplate.recipientDetails?.recipientType;
            if (type) {
                setSelectedOptionRecipientType(type);
            }
        }
    }, [paymentBankTemplate]);

    const getFees = async (obj: any) => {

        const preparedData = PrepareDataForBankTransaction(obj)

        const resp = await dispatch(getFeesForTransaction(token, preparedData))

        return resp
    }

    const getChallengeData = async (obj: any) => {
        const preparedData = PrepareDataForBankTransaction(obj)

        const resp = await dispatch(getChallengeDataThunk(token, preparedData))

        return resp
    }

    const myInitValues = {
        fullName: paymentBankTemplate?.recipientDetails?.beneficiaryName,
        recipientsIban: paymentBankTemplate?.recipientDetails?.iban || paymentBankTemplate?.recipientDetails?.ibanCode,
        recipientsSwiftBic: paymentBankTemplate?.recipientDetails?.swiftCode,
        recipientsAddress: paymentBankTemplate?.recipientDetails?.beneficiaryAddress,
        recipientsAccountNumber: paymentBankTemplate?.recipientDetails?.beneficiaryAccountNumber,
        sortCode: paymentBankTemplate?.recipientDetails?.beneficiarySortCode,
        paymentRegions: paymentBankTemplate?.paymentType === 'sepa' ? paymentBankTemplate?.paymentType.toUpperCase() : paymentBankTemplate?.paymentType,
        payerAccount: paymentBankTemplate?.fromAccountMainIban,
        hiddenAccountNumberFrom: paymentBankTemplate?.account,
        name: paymentBankTemplate?.recipientDetails.firstName,
        surname: paymentBankTemplate?.recipientDetails.lastName,
        recipientPostCode: paymentBankTemplate?.recipientDetails.recipientPostCode,
        companyName: paymentBankTemplate?.recipientDetails.companyName,
        bankName: paymentBankTemplate?.recipientDetails.bankName,
        bankAddress: paymentBankTemplate?.recipientDetails.bankAddress,
        bankCity: paymentBankTemplate?.recipientDetails.bankCity,
        bankPostCode: paymentBankTemplate?.recipientDetails.bankPostCode,
        bankCountry: paymentBankTemplate?.recipientDetails.bankCountry,
        fedwireRoutingNumber: paymentBankTemplate?.recipientDetails.fedwireRoutingNumber,
        achRoutingNumber: paymentBankTemplate?.recipientDetails.achRoutingNumber,
        invoice: {
            name: '',
            data: ''
        },
        type: 'international',
        recipientCity: paymentBankTemplate?.recipientDetails.beneficiaryCity,
        recipientCountry: paymentBankTemplate?.recipientDetails.beneficiaryCountry,
        amount: '',
        recipientType: paymentBankTemplate?.recipientType || paymentBankTemplate?.recipientDetails?.recipientType || 'INDIVIDUAL',
        reference: paymentBankTemplate?.recipientDetails?.reference
    }

    const closeAndRedirect = () => {
        setIsShowPaymentSentSuccessModal(false)
        navigate(-1)
    }

    return (
        <div className={s.form_wrapper}>

            <CustomModal isModalOpen={isShowPaymentSentSuccessModal} isNotify>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.success}>Success!</span> Your request has been sent
                        successfully.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn
                            isPersonalAccountBtn
                            title={"Ok"}
                            onClick={() => closeAndRedirect()}
                        />
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isNotify isModalOpen={isLimitPopupOpen} setIsModalOpen={setIsLimitPopupOpen}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.error}>Failed!</span> The transaction is impossible due to
                        exceeding {limitType} limit.
                        Please contact <a className={styles.popup_link}
                                          href='mailto:support@luxpay.lt'>support@luxpay.lt</a>&nbsp;
                        if you have any questions.
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => errorAndRedirect()}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isNotify isModalOpen={isDocumentErrorModalOpen} setIsModalOpen={setIsDocumentErrorModalOpen}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span className={styles.error}>Failed!</span> {documentErrorModalText}
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => setIsDocumentErrorModalOpen(false)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isModalOpen={isErrorPopupOpen} setIsModalOpen={setIsErrorPopupOpen}>
                <div className={styles.modal_content}>
                    <div className={styles.popup_subtitle}>
                        <span
                            className={styles.error}>Failed!</span> {isTwoFaCodeValid ? "Invalid or expired 2FA code. Please try again" : "Your request was rejected. Please try again."}
                    </div>
                    <div className={styles.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={clearEmailPin}/>
                    </div>
                </div>
            </CustomModal>

            <motion.div
                initial={{opacity: 0, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
            >
                <Formik
                    enableReinitialize={true}
                    initialValues={myInitValues}
                    validationSchema={amountValidationSchema}
                    onSubmit={async (values, formikHelpers) => {

                        dispatch(setIsLoading(true))

                        if (isIbanWrong) {
                            dispatch(setIsLoading(false))
                            return
                        }

                        let tempData = {
                            ...values,
                            accountId: accountId,
                            transferCurrency: currency
                        };
                        try {

                            const feesData = await getFees(tempData)

                            const challengeData = await getChallengeData(tempData)

                            dispatch(setTransferDataPreview({
                                ...tempData,
                                fee: feesData.data.fee,
                                totalAmount: feesData.data.totalAmount,
                                challengeData: challengeData.data
                            }))

                            navigate('/personal-account/templates/transfer-data-preview')
                        } catch (e: any) {
                            dispatch(setIsLoading(false))

                            if (e.response.data === 'Invalid Iban') {
                                setIsDocumentErrorModalOpen(true)
                                setDocumentErrorModalText('Invalid IBAN. Please check the number and try again')
                            }

                            if (e.response.data === 'Not enough money to create transaction') {
                                setIsDocumentErrorModalOpen(true)
                                setDocumentErrorModalText('The transfer cannot be made due to insufficient funds.')
                            }

                            if (e.response.data === 'Canceling transaction because user has debts') {
                                setIsDocumentErrorModalOpen(true)
                                setDocumentErrorModalText('Canceling transaction because user has debts')
                            }

                            if (e.response.data === 'Daily Limit') {
                                setLimitType("daily")
                                setIsLimitPopupOpen(true)
                                return
                            }

                            if (e.response.data === 'Monthly Limit') {
                                setLimitType("monthly")
                                setIsLimitPopupOpen(true)
                                return
                            }
                        }
                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleSubmit,
                          setFieldValue,
                      }) =>

                        (
                            <form onSubmit={handleSubmit}>

                                <div className={s.row}>

                                    <div className={s.input_block}>
                                        <div className={s.input_label}>
                                            <span><span className={s.red}>*</span> Payer account</span>
                                            <Popover
                                                content={"Please select the account you wish to make a transfer from."}
                                                color={'#EEEFEF'}
                                                overlayInnerStyle={{
                                                    fontFamily: 'Manrope',
                                                    width: '280px',
                                                    padding: '13px 16px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#E7F0EC'
                                                }}
                                            >
                                                <img src={info} alt=""/>
                                            </Popover>
                                        </div>
                                        <CustomDropdownForAccounts
                                            items={accountsList}
                                            placeholder={"Please select the account"}
                                            id="payerAccount"
                                            name="payerAccount"
                                            isError={errors.payerAccount}
                                            touched={touched.payerAccount}
                                            disabled={props.id !== 'create'}
                                            setCurrency={(selectedCurrency) => {
                                                setCurrency(selectedCurrency);
                                            }}
                                        />
                                        {errors.payerAccount && touched.payerAccount &&
                                            <div className={s.error_message}>{errors.payerAccount}</div>}
                                    </div>

                                    <div className={s.input_block}>
                                        <div className={s.input_label}>
                                            <span><span className={s.red}>*</span> Payment type </span>
                                        </div>
                                        <CustomDropdown
                                            customId="paymentRegions"
                                            items={[]}
                                            placeholder={"Please select the payment type"}
                                            id="paymentRegions"
                                            name="paymentRegions"
                                            isError={errors.paymentRegions}
                                            touched={touched.paymentRegions}
                                            disable={props.id !== 'create' || !values.payerAccount}
                                        />
                                        {errors.paymentRegions && touched.paymentRegions &&
                                            <div className={s.error_message}>{errors.paymentRegions}</div>}
                                    </div>

                                </div>

                                {
                                    values.paymentRegions !== "" && currency !== "" &&
                                    <div>
                                        <div className={classnames(s.input_block, s.recipient_type_block)}>
                                            <div className={s.input_label}>
                                                <span>RECIPIENT TYPE</span>
                                            </div>
                                            <div className={s.flex_label}>
                                                <label className={s.flex_label}>
                                                    <CustomCheckbox
                                                        handleChange={() => {
                                                        }}
                                                        id="INDIVIDUAL"
                                                        name="INDIVIDUAL"
                                                        isChecked={selectedOptionRecipientType === "INDIVIDUAL" || selectedOptionRecipientType === undefined}
                                                    />
                                                    <span
                                                        className={
                                                            selectedOptionRecipientType ===
                                                            "INDIVIDUAL"
                                                                ? s.type_of_payment_active
                                                                : s.type_of_payment_inactive
                                                        }
                                                    >
                                                        INDIVIDUAL
                                                    </span>
                                                </label>
                                                <label className={s.flex_label}>
                                                    <CustomCheckbox
                                                        handleChange={() => {
                                                        }}
                                                        id="BUSINESS"
                                                        name="BUSINESS"
                                                        isChecked={
                                                            selectedOptionRecipientType ===
                                                            "BUSINESS"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            selectedOptionRecipientType ===
                                                            "BUSINESS"
                                                                ? s.type_of_payment_active
                                                                : s.type_of_payment_inactive
                                                        }
                                                    >
                                                        BUSINESS
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                }

                                {/*SEPA (for EUR)*/}
                                {
                                    values.paymentRegions === "SEPA" && currency === "EUR" &&
                                    <DomesticEur
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                        disabled={true}
                                        isTemplateCreation={false}
                                    />
                                }

                                {/*International (for EUR)*/}
                                {
                                    values.paymentRegions === "international" && currency === "EUR" &&
                                    <InternationalEur
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={true}
                                        isIbanWrong={isIbanWrong}
                                        isTemplateCreation={false}
                                    />
                                }

                                {/*Domestic (for GBP)*/}
                                {
                                    values.paymentRegions === "domestic" && currency === "GBP" &&
                                    <DomesticGbp
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={true}
                                        isIbanWrong={isIbanWrong}
                                        isTemplateCreation={false}
                                    />
                                }

                                {/*International (for GBP)*/}
                                {
                                    values.paymentRegions === "international" && currency === "GBP" &&
                                    <InternationalGbp
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={true}
                                        isIbanWrong={isIbanWrong}
                                        isTemplateCreation={false}
                                    />
                                }

                                {/*domestic (for USD)*/}
                                {
                                    values.paymentRegions === "domestic" && currency === "USD" &&
                                    <DomesticUsd
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        disabled={true}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                {/*ACH (for USD)*/}
                                {
                                    values.paymentRegions === "ACH" && currency === "USD" &&
                                    <AchUsd
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                {/*SWIFT (for USD)*/}
                                {
                                    values.paymentRegions === "SWIFT" && currency === "USD" &&
                                    <SwiftUsd
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                {/*Fedwire (for USD)*/}
                                {
                                    values.paymentRegions === "Fedwire" && currency === "USD" &&
                                    <UsdFedwire
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                    />
                                }

                                <div className={classnames(s.row, s.amount_block)}>

                                    <div className={s.mobile_row}>
                                        <div className={classnames(s.input_block, s.short)}>
                                            <div className={s.input_label}>
                                                <span><span className={s.red}>*</span> Amount</span>
                                                <Popover
                                                    content={"Select a currency and enter the transfer amount.\n" +
                                                        "In the account balance in the selected currency is insufficient, the system " +
                                                        "will automatically offer you to top up using funds in a different currency " +
                                                        "you have on the account."}
                                                    color={'#EEEFEF'}
                                                    overlayInnerStyle={{
                                                        fontFamily: 'Manrope',
                                                        width: '280px',
                                                        padding: '13px 16px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#E7F0EC'
                                                    }}
                                                >
                                                    <img src={info} alt=""/>
                                                </Popover>
                                            </div>
                                            <MyInput id={"amount"}
                                                     name={"amount"}
                                                     value={values.amount}
                                                     onChange={handleChange}
                                                     isError={errors.amount}
                                            />
                                            {errors.amount &&
                                                <div className={s.error_label}>{errors.amount}</div>}
                                        </div>

                                        <div className={s.languages_dropdown}>
                                            <MyInput
                                                id="transferCurrency"
                                                name="transferCurrency"
                                                value={currency}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <AddDoc
                                    invoice={values.invoice}
                                    setIsDocumentErrorModalOpen={setIsDocumentErrorModalOpen}
                                    setDocumentErrorModalText={setDocumentErrorModalText}
                                    setFieldValue={setFieldValue}
                                />

                                <div className={s.continue_block}>
                                    <div className={s.required}>
                                        <div>
                                            <span><span className={s.red}>*</span> required fields.</span>
                                        </div>
                                    </div>
                                </div>

                                <div className={s.buttonsWrapper}>
                                    <div className={s.button_block}>
                                        <TransparentButton title={'Back'}
                                                           isPersonalAccountBtn
                                                           large
                                                           icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                                           onClick={() => {
                                                               navigate(-1);
                                                           }}/>
                                    </div>

                                    <MyBtn title={'Continue'}
                                           large
                                           localDisable={props.isButtonDisable || localyDisabled}
                                           style={{width: isMobile ? '100%' : 180}}
                                           type="submit"
                                           isPersonalAccountBtn
                                    />
                                </div>

                                {isShowEmailPopUpCode ?
                                    (<PopUpTwoFaCodConfirm getPinTwoFa={getPinTwoFa} onClose={closeEmailPinPopUp}
                                                           submitForm={handleSubmit}/>
                                    ) : null}

                                <Persist name="transfer-form"/>

                                <CurrencyHelper
                                    accountsList={accountsList}
                                    payerAccount={values.payerAccount}
                                    hiddenAccountNumberFrom={values.hiddenAccountNumberFrom}
                                    setCurrency={setCurrency}
                                />

                                <SwiftCheckerHelper
                                    setFieldValue={setFieldValue}
                                    setIsIbanWrong={setIsIbanWrong}
                                    isAdditionalFields
                                    currency={currency}
                                />

                            </form>
                        )}
                </Formik>
            </motion.div>
        </div>
    );
};

export default PaymentByBankTransactionTemplate;
